import { Pipe, PipeTransform, inject } from '@angular/core';
import { MetaStore } from '@qtek/libs/store';
import { conformToMask, getPhoneMask } from '@qtek/shared/utils';

@Pipe({
  name: 'phone',
  pure: false,
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  private metaStore = inject(MetaStore);

  transform(tel: string, country: string, includeCode = true): string {
    this.metaStore.loadCountryCode();
    const phones = this.metaStore.countryCode();
    if (!phones?.length) {
      return tel;
    }
    return this.formatPhoneNumber(phones, tel, country, includeCode);
  }

  private formatPhoneNumber(
    phones: any[],
    tel: string,
    country: string,
    includeCode: boolean
  ): string {
    if (!tel) {
      return '';
    }

    const phoneCountry = phones.find(phone => phone.id === country);
    const value = tel.toString().trim().replace(/^\+/, '');

    if (phoneCountry) {
      return `${includeCode ? '+' + phoneCountry.cd + ' ' : ''}${
        conformToMask(value, getPhoneMask(phoneCountry.mask).mask, {
          guide: false,
        }).conformedValue
      }`;
    }
    const cleanTel = tel.toString().replace(/\D/g, '');

    return this.formatCleanPhoneNumber(cleanTel, tel);
  }

  private formatCleanPhoneNumber(phone: string, fullPhone: string): string {
    if (phone?.length === 11) {
      const countryCode = phone.slice(0, 1);
      const areaCode = phone.slice(1, 4);
      const midSection = phone.slice(4, 7);
      const lastSection = phone.slice(7);
      return `+${countryCode} (${areaCode}) ${midSection}-${lastSection}`;
    } else if (phone?.length === 10) {
      const areaCode = phone.slice(0, 3);
      const midSection = phone.slice(3, 6);
      const lastSection = phone.slice(6);
      return `(${areaCode}) ${midSection}-${lastSection}`;
    } else {
      return fullPhone;
    }
  }
}
